export const appName = "CoX";

export const backendURL = process.env.REACT_APP_BACKEND_URL;

//export const backendURL = "https://api-dev.pureit.ro";

//export const backendURL = "https://api.pureit.ro";
